export default "__VITE_ASSET__62cf3cb8__"